import "./_our-team-list-styles.scss";

 import './our-team-list';
